import axios from '@/utils/request.js'

export const getCompanyOrderInfoList = (comId) => { // 批发部明细查询
  return axios.get(`/goods/gas/order/getCompanyOrderInfoList/${comId}`)
}

export const getAgentMesslist = (agentId) => { // 钢瓶明细查询
  return axios.get(`/goods/bGlmCylinderCurrentStatus/getAgentMesslist/${agentId}`)
}

export const getAgentCustomerMesslist = (params) => { // 批发部钢瓶实际情况
  return axios.post('/goods/bGlmCylinderCurrentStatus/getAgentCustomerMesslist', params)
}

export const getCylinderNotFlowList = (params) => { // 未流通钢瓶
  return axios.post('/goods/gas/cylinder/getCylinderNotFlowList', params)
}

export const getCylinderExpList = (params) => { // 到期检测钢瓶
  return axios.post('/goods/gas/cylinder/getCylinderExpList', params)
}
export const getAllCompanyOrderInfoList = (params) => { // 查询所有公司销售部情况
  return axios.post('/goods/gas/order/getAllCompanyOrderInfoList', params)
}
